export function downloadData(url: string, filename: string) {
	const link = document.createElement('a');
	document.body.appendChild(link);
	link.download = filename;
	link.href = url;
	link.click();
	document.body.removeChild(link);
}